import { Component, OnInit } from '@angular/core';
import { EventService } from '../../core/services/event.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../core/services/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

interface Member {
  createdAt: string;
  description: string;
  email: string;
  id: string;
}

interface UserProfile {
  profilePicture?: { url: string } | null;
  regCode: string;
  position: string;
  description: string;
  description1: [];
  name: string;
  grade: string;
  firstLogin: string;
  dashboardSettings: {
    recentArticles: boolean;
    recentBooks: boolean;
    recentPosts: boolean;
    recentNews: boolean;
    myProfile: boolean;
    calendar: boolean;
    invitedEvents: boolean;
    upcomingEvents: boolean;
  } | null;
  _id: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './events.components.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Events',
    },
  ];

  date: any;
  data: any[] = [];
  tempData: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 10;
  searchValue = '';
  visible = false;
  user = { _id: '' };
  exceededLimit = false;

  isVisibleForm = false;
  isAttendanceForm = false;
  isReasonModalVisible = false;
  attendanceForm!: FormGroup;
  reasonForm!: FormGroup;
  selectedEvent: any = null;
  selectedEventID = '';

  loggedUser: UserProfile = {
    profilePicture: null,
    regCode: '',
    position: '',
    grade: '',
    description: '',
    description1: [],
    name: '',
    dashboardSettings: {
      recentArticles: true,
      recentBooks: true,
      recentPosts: true,
      recentNews: true,
      myProfile: true,
      calendar: true,
      invitedEvents: true,
      upcomingEvents: true,
    },
    firstLogin: '',
    _id: '',
  };

  Event = {
    id: '',
    name: 'title',
    thumbnail: { url: 'url' },
    resources: 'content',
    agenda: 'agenda',
    startTime: 'datetime',
    endTime: 'end Time',
    venue: 'venue',
    eventType: 'eventType',
    member: [
      {
        id: '',
        name: 'name',
        position: 'position',
        workplace: 'workplace',
        profilePicture: { url: '' },
      },
    ],
    accepted: [
      {
        id: '',
        name: 'name',
        position: 'position',
        workplace: 'workplace',
        profilePicture: { url: '' },
      },
    ],
    rejected: [
      {
        id: '',
        name: 'name',
        position: 'position',
        workplace: 'workplace',
        profilePicture: { url: '' },
      },
    ],
    media: [{ url: 'url', mimeType: 'type', filename: 'fileName' }],
    link: '',
    openEventConditions: '',
  };

  constructor(
    private message: NzMessageService,
    private authService: AuthService,
    private eventService: EventService,
    private router: Router,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser();
    this.loadEvents();
    this.user = this.authService.getLoggedInUser();
    this.loggedUser = this.authService.getLoggedInUser();
    this.initAttendanceForm();
    this.initReasonForm();
  }

  initReasonForm(): void {
    this.reasonForm = this.formBuilder.group({
      reason: ['', Validators.required],
    });
  }

  onChange(date: any): void {
    this.data = this.tempData;
    if (date === null) {
      this.loadEvents();
    } else {
      this.data = this.filterEventsByStartDate(this.data, date);
    }
  }

  filterEventsByStartDate(originalEvents: any[], dateToCompare: Date): any[] {
    return originalEvents.filter((event) => {
      const startDate = new Date(event.startTime);
      return (
        startDate.getFullYear() === dateToCompare.getFullYear() &&
        startDate.getMonth() === dateToCompare.getMonth() &&
        startDate.getDate() === dateToCompare.getDate()
      );
    });
  }

  loadEvents(): void {
    this.eventService
      .getEvents(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.tempData = response.docs;
        this.totalDocs = response.totalDocs;
        this.sortEventsByStartDate();
      });
  }

  formatDate(startDate: string, endDate: string): string {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 'Invalid Date Range';
    }
  
    // Format both date and time together for start and end
    const dateTimeOptions: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
  
    const startFormatted = new Intl.DateTimeFormat('en-US', dateTimeOptions)
      .format(start)
      .replace(',', '')
      .replace(' at ', ' - ');
    
    const endFormatted = new Intl.DateTimeFormat('en-US', dateTimeOptions)
      .format(end)
      .replace(',', '')
      .replace(' at ', ' - ');
  
    return `${startFormatted} | ${endFormatted}`;
  }

  getEventsBySearch(): void {
    this.eventService
      .getEventsBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
        this.sortEventsByStartDate();
      });
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.loadEvents();
  }

  viewEvent(id: any): void {
    this.router.navigate(['/admin/single-event/', { id }]);
  }

  addParticipant(reply: any, event: any): void {
    let payload: {
      accepted?: string[];
      rejected?: string[];
      member?: string[];
      willAttend?: string[];
      willNotAttend?: string[];
    } = {}; // Initialize as an object
    let memberAcceptedIds: string[] = [];
    let memberInvitedIds: string[] = [];
    let rejectedIds: string[] = [];
    let willAttendIds: string[] = [];
    let willNotAttendIds: string[] = [];

    if (this.user._id) {
      if (reply === 'Add') {
        if (event.accepted) {
          memberAcceptedIds = event.accepted.map((member: Member) => member.id);
        }
        memberAcceptedIds.push(this.user._id);
        payload = { accepted: memberAcceptedIds };
        if (event.member) {
          if (
            event.member.some(
              (item: { id: string }) => item.id === this.user._id,
            )
          ) {
            memberInvitedIds = event.member
              .filter((item: Member) => item.id !== this.user._id)
              .map((item: Member) => item.id);
            payload = { accepted: memberAcceptedIds, member: memberInvitedIds };
          }
        }
        this.eventService.updateEvent(event.id, payload).then(() => {
          this.message.create(
            'success',
            `Registered for the event successfully!`,
          );
          this.ngOnInit();
        });
      } else if (reply === 'Reject') {
        if (event.rejected) {
          rejectedIds = event.rejected.map((member: Member) => member.id);
        }
        rejectedIds.push(this.user._id);

        memberInvitedIds = event.member
          .filter((item: Member) => item.id !== this.user._id)
          .map((item: Member) => item.id);
        payload = { rejected: rejectedIds, member: memberInvitedIds };

        this.eventService.updateEvent(event.id, payload).then(() => {
          this.message.create(
            'success',
            `Participation rejected successfully!`,
          );
          this.ngOnInit();
        });
      } else if (reply === 'WillAttend') {
        // Handle RSVP: I will attend
        if (event.willAttend) {
          willAttendIds = event.willAttend.map((member: Member) => member.id);
        }
        // Remove from willNotAttend if present
        if (event.willNotAttend) {
          willNotAttendIds = event.willNotAttend
            .filter((item: { id: string }) => item.id !== this.user._id)
            .map((item: { id: string }) => item.id);
        }
        // Add to willAttend if not already present
        if (!willAttendIds.includes(this.user._id)) {
          willAttendIds.push(this.user._id);
        }
        payload = { willAttend: willAttendIds, willNotAttend: willNotAttendIds };

        this.eventService.updateEvent(event.id, payload).then(() => {
          this.message.create(
            'success',
            `Your response "I will attend" has been recorded!`,
          );
          this.ngOnInit();
        });
      } else if (reply === 'WillNotAttend') {
        // Show reason modal
        this.selectedEvent = event;
        this.isReasonModalVisible = true;
      }
    }
  }

  hasRSVPResponse(event: any): boolean {
    const willAttend = event.willAttend?.some(
      (item: { id: string }) => item.id === this.user._id
    );
    const willNotAttend = event.willNotAttend?.some(
      (item: { id: string }) => item.id === this.user._id
    );
    return willAttend || willNotAttend || false;
  }

  getRSVPResponse(event: any): string {
    if (event.willAttend?.some((item: { id: string }) => item.id === this.user._id)) {
      return 'willAttend';
    }
    if (event.willNotAttend?.some((item: { id: string }) => item.id === this.user._id)) {
      return 'willNotAttend';
    }
    return 'none';
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  isVisible(data: any, flag: any): boolean {
    // All events are now open, so always show attendance buttons
    return true;
  }

  showLink(): boolean {
    // Show link if it exists and is not empty
    return true;
  }

  isExpired(date: any): boolean {
    const inputDate = new Date(date);
    // Get the current date
    const currentDate = new Date();
    // Compare the two dates
    return inputDate.getTime() >= currentDate.getTime();
  }

  serializeToHTML(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText =
            node.text.length > 250
              ? `${node.text.slice(0, 250)}...`
              : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `${text}`;
          }

          if (node.code) {
            text = `${text}`;
          }

          if (node.italic) {
            text = `${text}`;
          }

          if (node.underline) {
            text = `${text}`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h2':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h3':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h4':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h5':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h6':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<p>${this.serializeToHTML(node.children)}</p>`;

          default:
            return `<p class="text-[#706D6D] font-[400] ">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 250 ? `${result.slice(0, 250)}...` : result;
  }

  private escapeHTML(text: string): string {
    return text;
  }

  handleCancel(): void {
    this.isVisibleForm = false;
    this.isAttendanceForm = false;
    this.isReasonModalVisible = false;
    this.reasonForm.reset();
    this.selectedEvent = null;
    // this.event = null;
  }

  handleReasonSubmit(): void {
    if (this.reasonForm.invalid) {
      for (const i in this.reasonForm.controls) {
        if (this.reasonForm.controls.hasOwnProperty(i)) {
          this.reasonForm.controls[i].markAsDirty();
          this.reasonForm.controls[i].updateValueAndValidity();
        }
      }
      return;
    }

    if (!this.selectedEvent) {
      return;
    }

    const reason = this.reasonForm.value.reason;
    let payload: {
      willAttend?: string[];
      willNotAttend?: string[];
      willNotAttendReasons?: any[];
    } = {};
    let willAttendIds: string[] = [];
    let willNotAttendIds: string[] = [];
    let reasons: any[] = [];

    // Get existing reasons
    if (this.selectedEvent.willNotAttendReasons) {
      reasons = [...this.selectedEvent.willNotAttendReasons];
    }

    // Remove existing reason for this user if any
    reasons = reasons.filter((r: any) => {
      const memberId = typeof r.member === 'string' ? r.member : r.member?.id;
      return memberId !== this.user._id;
    });

    // Add new reason
    reasons.push({
      member: this.user._id,
      reason: reason,
    });

    // Handle willNotAttend list
    if (this.selectedEvent.willNotAttend) {
      willNotAttendIds = this.selectedEvent.willNotAttend.map(
        (member: Member) => member.id,
      );
    }
    // Remove from willAttend if present
    if (this.selectedEvent.willAttend) {
      willAttendIds = this.selectedEvent.willAttend
        .filter((item: { id: string }) => item.id !== this.user._id)
        .map((item: { id: string }) => item.id);
    }
    // Add to willNotAttend if not already present
    if (!willNotAttendIds.includes(this.user._id)) {
      willNotAttendIds.push(this.user._id);
    }

    payload = {
      willAttend: willAttendIds,
      willNotAttend: willNotAttendIds,
      willNotAttendReasons: reasons,
    };

    this.eventService.updateEvent(this.selectedEvent.id, payload).then(() => {
      this.message.create(
        'success',
        `Your response "I will not attend" with reason has been recorded!`,
      );
      this.isReasonModalVisible = false;
      this.reasonForm.reset();
      this.selectedEvent = null;
      this.ngOnInit();
    });
  }
  
  // Attendence Form
  attendance: {
    name: string;
    designation: string;
    station: string;
    adultCount: string;
    childrenCount: string;
    childrenAge: string;
    roomType: string;
    datesOfStay: string;
  } = {
    name: '',
    designation: '',
    station: '',
    adultCount: '',
    childrenCount: '',
    childrenAge: '',
    roomType: '',
    datesOfStay: '',
  };

  initAttendanceForm(): void {
    this.attendanceForm = this.formBuilder.group({
      name: [this.attendance?.name || ''],
      designation: [this.attendance?.designation || '', Validators.required],
      station: [this.attendance?.station || '', Validators.required],
      adultCount: [
        this.attendance?.adultCount || '',
        [Validators.required, Validators.pattern('^[0-9]*$')],
      ],
      childrenCount: [
        this.attendance?.childrenCount || '',
        [Validators.required, Validators.pattern('^[0-9]*$')],
      ],
      childrenAge: [this.attendance?.childrenAge || ''],
      roomType: [this.attendance?.roomType || '', Validators.required],
      datesOfStay: [this.attendance?.datesOfStay || '', Validators.required],
    });
  }

  getFormControl(controlName: string) {
    return this.attendanceForm.get(controlName);
  }

  sortEventsByStartDate(): void {
    this.data.sort((a, b) => {
      return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
    });
  }

  showModalAttendence(event: any): void {
    this.isVisibleForm = true;
    this.isAttendanceForm = true;
    this.selectedEventID = event.id;
    this.selectedEvent = event;
 
  }

  handleAttendanceFormSubmit(): void {
    if (this.attendanceForm.invalid) {
      for (const i in this.attendanceForm.controls) {
        if (this.attendanceForm.controls.hasOwnProperty(i)) {
          this.attendanceForm.controls[i].markAsDirty();
          this.attendanceForm.controls[i].updateValueAndValidity();
        }
      }
      return;
    }

    const formData = this.attendanceForm.value;
    const newAttendee = {
      name: this.loggedUser.name,
      designation: formData.designation,
      station: formData.station,
      adultCount: formData.adultCount,
      childrenCount: formData.childrenCount,
      childrenAge: formData.childrenAge,
      roomType: formData.roomType,
      datesOfStay: formData.datesOfStay,
    };

    this.eventService
      .getEventsById(this.selectedEventID)
      .then((event) => {
        const currentAttendees = event.attendees || [];
        const updatedAttendees = [...currentAttendees, newAttendee];

        this.eventService
          .updateEvent(this.selectedEventID, { attendees: updatedAttendees })
          .then(() => {
            this.addParticipant('Add', this.selectedEvent);
            this.message.create(
              'success',
              'Registration Status Updated Successfully',
            );
          })
          .catch(() => {
            this.message.create('error', 'Failed to Update Event Registration');
          });

        this.isVisibleForm = false;
        this.isAttendanceForm = false;
      })
      .catch(() => {
        this.message.create('error', 'Failed to Fetch Current Attendees');
      });
  }

  // attendence form ends
}
